import { ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Container } from './DateSelect.styled';
import DatePicker, { registerLocale } from 'react-datepicker';
import { da } from 'date-fns/locale/da';
import { enGB as en } from 'date-fns/locale/en-GB';
import { useDetectClickOutside } from 'react-detect-click-outside';

registerLocale('da', da);
registerLocale('en-GB', en);


interface IProps {
  children:ReactNode,
  setDate: (type, date) => void,
  value:Date,
  type: number
}

export const DateSelect = (props: IProps) => {
  const i18n = useI18n();
  useEffect(() => {}, []);
  const [open, setOpen] = useState(false)
  const ClickOutside = (e) => {
    if(e.target.classList?.contains('react-datepicker__navigation') || e.target.classList.contains('react-datepicker__current-month'))return
    setOpen(false);
  };
  const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  const handleClose = (e) => {
    if(e.target.classList?.contains('react-datepicker__navigation') || e.target.classList.contains('react-datepicker__current-month'))return
    setOpen(!open)
  }

  return (
    <Container onClick={handleClose} ref={ref}>
      <DatePicker 
        open={open}
        locale={i18n.language === 'da' ? da : 'en-GB'}
        selected={props.value} 
        onChange={(date: Date | null) => props.setDate(props.type, date)} 
        customInput={<>{props.children}</>} 
        minDate={new Date()}
        popperPlacement="bottom-end"
      />
    </Container>
  );
};

export default DateSelect;
